import { useTranslation } from "react-i18next";

import css from "./empty.module.scss";

export const EmptyActivities = () => {
  const { t } = useTranslation("search");

  return (
    <div className={css.root}>
      <strong>{t("results.noActivitiesFound")}</strong>
      <p>{t("results.tryChangingSearch")}</p>
    </div>
  );
};
